export const DEFAULT_INTERNAL_CREW_TYPE_NAME = 'INTERNAL';
export const UNDEFINED_CREW_TYPE_NAME = 'Undefined';
